// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_refpend-header__caw0n {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: var(--referral-border-color2);
    border-bottom: 1px solid var(--referral-gray);
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    position: relative;
    height: 68px;
  }

  .style_title__eWRLl{
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
  }
  
  .style_sticky__xiMcY {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  
  .style_left__lLTEu {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .style_back-arrow__M1GbI {
    color: purple;
    font-size: 16px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    margin: auto;
    text-align: center;
    justify-content: center;
  }
  
  .style_right__6n1Ta {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .style_smiley__mk7uU {
    font-size: 22px;
    cursor: pointer;
  }
  .style_pandingBackgroundImage__0hO9j{
    padding: 12px 16px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Header/RefPend/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB","sourcesContent":[".refpend-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    background: var(--referral-border-color2);\n    border-bottom: 1px solid var(--referral-gray);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19px;\n    position: relative;\n    height: 68px;\n  }\n\n  .title{\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19px;\n  }\n  \n  .sticky {\n    position: sticky;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n  }\n  \n  .left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .back-arrow {\n    color: purple;\n    font-size: 16px;\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    margin: auto;\n    text-align: center;\n    justify-content: center;\n  }\n  \n  .right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .smiley {\n    font-size: 22px;\n    cursor: pointer;\n  }\n  .pandingBackgroundImage{\n    padding: 12px 16px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"refpend-header": `style_refpend-header__caw0n`,
	"title": `style_title__eWRLl`,
	"sticky": `style_sticky__xiMcY`,
	"left": `style_left__lLTEu`,
	"back-arrow": `style_back-arrow__M1GbI`,
	"right": `style_right__6n1Ta`,
	"smiley": `style_smiley__mk7uU`,
	"pandingBackgroundImage": `style_pandingBackgroundImage__0hO9j`
};
export default ___CSS_LOADER_EXPORT___;
